import { AUCTION_COUNTDOWN_MS } from "@grundbesitz/shared";
import { countdownFraction } from "../../../lib/assets";
import { secondsUntil, serverNow } from "../../../lib/store";
import { useTick } from "../assets/useTick";

/**
 * Countdown bar and seconds. The server timer restarts with every bid, so the bar jumps back to full.
 * Not a live region: screen readers get the bids announced, not every second.
 */
export function Countdown({ endsAt }: { endsAt: number | null }) {
  useTick(endsAt !== null, 100);
  if (endsAt === null) {
    return <p className="text-sm text-ink-2">Die Versteigerung endet, sobald niemand mehr bietet.</p>;
  }
  const fraction = countdownFraction(endsAt, serverNow(), AUCTION_COUNTDOWN_MS);
  const seconds = secondsUntil(endsAt) ?? 0;
  const urgent = seconds <= 3;
  return (
    <div role="timer" aria-label={`Noch ${seconds} Sekunden ohne neues Gebot`} className="flex items-center gap-3">
      <div className="h-2.5 flex-1 overflow-hidden rounded-full bg-surface-2" aria-hidden="true">
        <div
          className={`h-full origin-left rounded-full transition-[width] duration-100 ease-linear ${urgent ? "bg-danger" : "bg-accent"}`}
          style={{ width: `${fraction * 100}%` }}
        />
      </div>
      <span aria-hidden="true" className={`w-10 text-right font-display text-xl font-bold tabular-nums ${urgent ? "text-danger" : ""}`}>
        {seconds} s
      </span>
    </div>
  );
}
